import { useTimelineStatusMaxHeight } from '@components'

import { useCallback, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { DocumentTimelineStatus } from '@features/invoices/elements/DocumentTimelineStatus'
import { QuoteEvent } from '@features/invoices/types/quotes/quoteEvent'

import { useQuote } from '../../../../contexts/quoteContext'
import { useSupportedQuoteStatusEvents } from '../../hooks/useSupportedQuoteStatusEvents'
import * as Styled from './styles'
import { getQuoteTimelineStatusTranslationKey } from './utils/getQuoteTimelineStatusTranslationKey'

export const QuoteTimelineStatus = () => {
  const { t } = useTranslation()
  const { quote } = useQuote()
  const { statusEvents, isLoading } = useSupportedQuoteStatusEvents()
  const timelineStatusWrapperRef = useRef<HTMLDivElement>(null)
  const { maxHeight } = useTimelineStatusMaxHeight({ isLoading, ref: timelineStatusWrapperRef })

  const getItemTitle = useCallback(
    (event: QuoteEvent): string => t(getQuoteTimelineStatusTranslationKey(event, quote?.relatedInvoices)),
    [t, quote?.relatedInvoices],
  )

  return (
    <Styled.DocumentTimelineStatusWrapper ref={timelineStatusWrapperRef}>
      <DocumentTimelineStatus
        events={statusEvents}
        getItemTitle={getItemTitle}
        isLoading={isLoading}
        maxHeight={maxHeight}
        title={t('quotes.view.sidebar.timeline.title')}
      />
    </Styled.DocumentTimelineStatusWrapper>
  )
}
